export default "__VITE_ASSET__BRTdfLox__"